let translations = {};

export const loadTranslations = async () => {
	let RALARSA_URL =
		process.env.REACT_APP_RALARSA_URL || "https://www.ralarsa.com";

	const lang =
		new URLSearchParams(window.location.search).get("lang") || "es_ES";
	// console.log("Cargando traducciones para el idioma:", lang);

	try {
		const res = await fetch(
			`${RALARSA_URL}/wp-content/themes/ralarsa/translations.php?lang=${lang}`
		);
		// console.log("Cargando traducciones desde:", res.url);
		if (!res.ok) throw new Error("No se pudo cargar traducciones");
		translations = await res.json();
	} catch (err) {
		console.error("Error cargando traducciones:", err);
		translations = {};
	}
};

export const t = (key, ...params) => {
	if (typeof key !== "string") {
		// console.warn(`❗️Clave de traducción inválida: ${key}`);
		return "";
	}

	const str = translations[key];
	if (!str) {
		// console.warn(`🔍 Clave no encontrada: "${key}"`);
	}

	let i = 0;
	return (str || key).replace(/%s/g, () => params[i++] ?? "");
};
